import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink
} from 'reactstrap';

import './TabsComponent.css';

const TabsComponent = (props) => {
  const [activeTab, setActiveTab] = useState('');

  useEffect(() => {
    const { contentList } = props;

    if (!contentList || contentList.length === 0) return;

    const { tabId } = contentList[0];

    if (!tabId) return;

    setActiveTab(tabId);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const { contentList, readOnly, blockedEdition } = props;

  const toggleTab = tab => {
    if (activeTab === tab) return;
    
    setActiveTab(tab);
  }

  const getActiveTabManagementButton = () => {
    const filteredData = contentList.find(contentData => (contentData.tabId === activeTab));

    if (!filteredData) return <></>;

    if (!filteredData.managementButton) return <></>;

    return (
      <li className="tab-button">
        {filteredData.managementButton}
      </li>
    );
  };

  const customNavClass = `tabs-menu__component ${(!readOnly && blockedEdition) ? 'dirty-prevent' : ''}`;
  const customTabContentClass = `tabs-content__component ${(!readOnly && blockedEdition) ? 'dirty-prevent' : ''}`;

  const applyCssWhenCondition = (condition, cssClasses) =>{
    return condition
        ? cssClasses
        : '';
  };

  const handleToggleTab = (tabId, isDisabled, toggleTab) => {
    if (!isDisabled) {
      toggleTab(tabId);
    }
  };
  return (
    <>
      <Nav tabs className={customNavClass}>
        {
          contentList.map((dataObj) => {
            const { tabTitle, tabId, errorTab, disabled, disabledTooltip } = dataObj;
            const isDisabled = !!disabled;
            const itemClass = `${applyCssWhenCondition(errorTab,'wrong-tab')} ${applyCssWhenCondition(isDisabled, 'disabled-tab')}`.trim();

            return(
              <NavItem
                key={`${tabTitle}-${tabId}`}
                data-test-id={tabId}
                className={itemClass}
              >
                <NavLink
                    className={`${(activeTab === tabId) ? 'active' : ''}`}
                    onClick={() => handleToggleTab(tabId, isDisabled, toggleTab)}
                    aria-disabled={isDisabled}
                    title={isDisabled ? (disabledTooltip || '') : undefined}
                >
                  {tabTitle}
                </NavLink>
              </NavItem>
            );
          })
        }
        {(!readOnly) && getActiveTabManagementButton()}
      </Nav>
      <TabContent activeTab={activeTab} className={customTabContentClass}>
        {
          contentList.map((dataObj) => {
            const { childComponent, tabId } = dataObj;

            return(
              <TabPane key={`TabPaneContent-${tabId}`} tabId={tabId}>
                {childComponent}
              </TabPane>
            );
          })
        }
      </TabContent>
    </>
  );
};

TabsComponent.propTypes = {
  contentList: PropTypes.arrayOf(PropTypes.object),
  readOnly: PropTypes.bool,
  blockedEdition: PropTypes.bool
};

TabsComponent.defaultProps = {
  contentList: [],
  readOnly: false,
  blockedEdition: false
};

export default TabsComponent;
